import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';
import { JQueryHelperService } from '../../shared/models/jquery-helper.service';
import { CustomerAdminInvitationModel } from '../../admin-invite-popup/models/admin-to-invite.model';


@Injectable()
export class AdminOfCustomerService {
    constructor(private authService: AuthService, private http: Http) { }
    
    private JQueryHelper: JQueryHelperService = new JQueryHelperService();

    public GetAdminOfCustomerList(customerHashID: string, input?: DataListModel): Observable<IAPIResponse> {
        let getComapanyAdminUrl = WeGoConfig.API_GET_ADMIN_OF_CUSTOMER_LIST;
        let queryString = this.authService.HandleAPIListInput(input);
        if (queryString) {
            getComapanyAdminUrl = getComapanyAdminUrl + "?" + queryString + "&customerHashID=" + customerHashID;
        }
        else {
            getComapanyAdminUrl = getComapanyAdminUrl + "?customerHashID=" + customerHashID;
        }
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getComapanyAdminUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public ExportAdminOfCustomerList(customerHashId: string, input?: DataListModel): any {
        input.currentPage = 0;
        let queryString = this.authService.HandleAPIListInput(input);
        let getCompanyAdminUrl = WeGoConfig.API_EXPORT_ADMIN_OF_CUSTOMER_LIST + "?" + queryString + "&customerHashId=" + customerHashId;
        let headers = this.authService.GetHeader('text/csv');
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getCompanyAdminUrl, options);
    }

    public DeleteAdminOfCustomer(customerHashId: string, selectedAdminOfCustomerList: string[]): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        let urlDeleteAdminOfCustomer = WeGoConfig.API_POST_DELETE_ADMIN_OF_CUSTOMER + "?customerHashId=" + customerHashId;

        return this.http.post(urlDeleteAdminOfCustomer, selectedAdminOfCustomerList, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public GetAllRoleAvailability(input?: DataListModel, customerHashId?: string): Observable<IAPIResponse> {
        let getRoleAvailabilityListUrl = WeGoConfig.API_GET_CUSTOMER_ROLEAVAILABILITY_LIST + "?customerHashID=" + customerHashId;
        let queryString = this.authService.HandleAPIListInput(input);
        if (queryString) {
            getRoleAvailabilityListUrl = getRoleAvailabilityListUrl + "&" + queryString;
        }
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getRoleAvailabilityListUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public DeleteAdminOfCustomerRole(customerHashId: string, personHashId: string, roleHashId: string): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        let urlDeleteAdminOfCustomer = WeGoConfig.API_POST_DELETE_ADMIN_OF_CUSTOMER_ROLE + "?customerHashId=" + customerHashId + "&personHashId=" + personHashId + "&roleHashId=" + roleHashId;

        return this.http.get(urlDeleteAdminOfCustomer, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public AddAdminOfCustomerRole(customerHashId: string, personHashId: string, roleHashId: string): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        let urlAddAdminOfCustomer = WeGoConfig.API_POST_ADD_ADMIN_OF_CUSTOMER_ROLE + "?customerHashId=" + customerHashId + "&personHashId=" + personHashId + "&roleHashId=" + roleHashId;;

        return this.http.get(urlAddAdminOfCustomer, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }
    
    public GetPersonListToInvite(customerHashID: string, emailAddress: string): Observable<IAPIResponse> {
        let getComapanyAdminUrl = WeGoConfig.API_GET_CUSTOMER_PERSON_TO_INVITE_LIST

        getComapanyAdminUrl = getComapanyAdminUrl + "?customerHashID=" + customerHashID + "&emailAddress=" + emailAddress;

        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getComapanyAdminUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public InviteAdminOfCustomer(customerAdminInvitationModel:CustomerAdminInvitationModel): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        let urlInviteAdminOfCustomer = WeGoConfig.API_POST_INVITE_ADMIN_OF_CUSTOMER ;      

        return this.http.post(urlInviteAdminOfCustomer, customerAdminInvitationModel, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-of-customer/models/admin-of-customer.service.ts